import { obtainAccessToken } from "./apollo";

const getAuthorization = async () => {
    const data = await obtainAccessToken();
    const accessToken = data && data.auth && data.auth.accessToken;
    return accessToken && accessToken.raw ? `Bearer ${accessToken.raw}` : "";
};

const authFetch = async (request: Request | string) => {
    request = new Request(request, {
        credentials: "same-origin",
    });

    const auth = await getAuthorization();
    request.headers.append("Authorization", auth);

    const response = await fetch(request);
    if (response.ok) return response;

    throw Error(response.statusText);
};

export default authFetch;
